import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {multipleSelector_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template';

declare var ko: any;

export class staticPagesList_template extends vnTemplate {

    public static YES_OR_NO = [
        {id: 1, name: "Yes"},
        {id: 0, name: "No"}
    ];

    //As VM
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected filter: filterSimple_template;
    protected indexedFilter: multipleSelector_template;

    protected initPartial() {
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.indexedFilter = new multipleSelector_template("indexedFilter", this.getTemplateViewModel(), this.caller);
        this.indexedFilter.setLabel('Indexed');
        this.indexedFilter.setFilterContainerClass('margin-neg');
        this.indexedFilter.setTagContainerId('selected-indexed');
        this.indexedFilter.setTagContainerCaption('Selected Indexed:');
        this.indexedFilter.setItems(staticPagesList_template.YES_OR_NO);
    }

    public getViewModelForRequest(): any {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                indexed: this.getTemplateViewModel().indexedFilter.selectedItems
            }
        }
    }

    protected buildViewModel(): any {
        let self = this
        return {
            staticpages: ko.observableArray([]),
            orderBy: ko.observable("dateUpdated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateUpdated_DESC"),
            idStaticPageToDelete: ko.observable(null),
            permissions : ko.observableArray(self.initPermissions(['static_pages_about'])),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewStaticPage: (data, event) => {
                self.viewStaticPage(data.id, event);
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd()
            },
            onClickShowPopUp : (data, event) =>{
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp : (data, event)=>{
                self.onClickHidePopUp()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
        <div class="sub-header w-justify">
            <div class="w-left">
                ${this.indexedFilter.getHtmlBuild()}
            </div>
        </div>

        <div class="w-filters-selected">
            <div id="filters-selected" class="filters-selected">
                <div id="selected-indexed"></div>
            </div>
        </div>

        <div class="list-header w-justify">
            <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Add a static page</button>    
            </div>
            <div class="w-center">${this.filter.getHtmlBuild()}</div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>
        
        <div class="w-list-results" id="list-results">
            <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'permalink') }, css: { 'list-sort-desc': orderByAndDirection()=='permalink_DESC', 'list-sort-asc': orderByAndDirection()=='permalink_ASC' }">Permalink</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'description') }, css: { 'list-sort-desc': orderByAndDirection()=='description_DESC', 'list-sort-asc': orderByAndDirection()=='description_ASC' }">Description</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'category') }, css: { 'list-sort-desc': orderByAndDirection()=='category_DESC', 'list-sort-asc': orderByAndDirection()=='category_ASC' }">Category</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'indexed') }, css: { 'list-sort-desc': orderByAndDirection()=='indexed_DESC', 'list-sort-asc': orderByAndDirection()=='indexed_ASC' }">Indexed</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                            <th class="align-right"><span>Delete</span></th>
                            </tr>
                    </thead>

                    <tbody data-bind="foreach: staticpages">
                       <!-- ko if:  $data.permalink == '/page/about/' && ($parent.permissions()['static_pages_about'] && $parent.permissions()['static_pages_about'].read) || $data.permalink != '/page/about/' -->
                        <tr class="cursor">
                            <td data-bind=" if: name, event: { click: $parent.viewStaticPage }">
                                <a class="right-click" data-bind="attr: { href : emakiView }">
                                    <div class="flex">
                                        <span data-bind="text: name"></span>
                                        <button type="button" data-bind="event: { click: $parent.viewOnWebsite }" class="btn icon border only-icon i-link"/>
                                    </div>
                                </a>
                            </td>
                            <td data-bind=" if: permalink, event: { click: $parent.viewStaticPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: permalink"></span></a></td>
                            <td data-bind=" if: description, event: { click: $parent.viewStaticPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: description"></span></a></td>
                            <td data-bind=" if: category, event: { click: $parent.viewStaticPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: category || ''"></span></a></td>
                            <td data-bind="event: { click: $parent.viewStaticPage } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: indexed ? 'Yes' : 'No' "></span></a></td>
                            <td data-bind=" if: dateCreated, event: { click: $parent.viewStaticPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated.substring(0, 10)"></span></a></td>
                            <td data-bind=" if: dateUpdated, event: { click: $parent.viewStaticPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated.substring(0, 10)"></span></a></td>
                            <td data-bind="event: { click: $parent.viewStaticPage } " class="align-right"><button type="button" data-bind="event: { click: $parent.onClickShowPopUp }, clickBubble: false" class="btn border only-icon icon i-delete"></button></td>
                        </tr>
                        <!-- /ko -->
                    </tbody>
                </table>
            </div> 
            
            
            <div id="delete-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Deleting static page</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to delete this static page :

                                    <p data-bind=" if: idStaticPageToDelete() !== null ">
                                       <span data-bind="text: idStaticPageToDelete().name"></span>
                                    </p>

                                </p>
                            </div>
                         </div>
                
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                        </div>
                    </div>
                   
                </div>
            </div>
        `);
    }

    protected getTemplateName(): string {
        return "staticPagesList_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected viewStaticPage(data, event): any {
        this.caller.viewStaticPage(data)
    }

    protected onClickReorder(value, data, event): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.staticPagesListReorder();
    }

    private viewOnWebsite(value) {

        //prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();
        this.caller.viewOnWebsite(value.permalink);
    }

    onClickAdd(): any {
        this.caller.addStaticPage()
    }

    onClickDelete() {
        let static_page_id = this.getTemplateViewModel().idStaticPageToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteStaticPage(static_page_id);
    }

    onClickHidePopUp(): any {
        this.getTemplateViewModel().idStaticPageToDelete(null);
        this.toggleDeleteDialogVisibility()
    }
    onClickShowPopUp(data): any {

        this.getTemplateViewModel().idStaticPageToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    //Action on view model
    protected setStaticPages(staticpages, brandId) {

        staticpages.forEach((sp) => sp['emakiView'] = '/brand/' + brandId + '/config/static-pages/view/' + sp.id);

        this.getTemplateViewModel().staticpages(staticpages)
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    public setPermissions(permissions){
        this.getTemplateViewModel().permissions(permissions);
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/staticPagesList_template.ts